module.exports = __webpack_public_path__ + "img/hardwareRouter1.39ff0112.png";